type LogLevel = "info" | "warn" | "error";

const getTodayKey = () => `qr_logs_${new Date().toISOString().slice(0, 10)}`;

export const browserLog = (level: LogLevel, message: string, data?: any) => {
  try {
    const key = getTodayKey();
    const existing = JSON.parse(localStorage.getItem(key) || "[]");

    existing.push({
      time: new Date().toISOString(),
      level,
      message,
      data,
    });

    localStorage.setItem(key, JSON.stringify(existing));
  } catch (e) {
    console.error("browserLog failed", e);
  }
};
